(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cust-easter-calendar"] && !window.DesignMode) return;
  try {
    
  function displayInfoDetails() {
    const infoButtons = document.querySelectorAll('.cust-easter-calendar__info-btn');

    infoButtons.forEach(infoButton => {
      // Remove existing event listeners to prevent conflicts
      const newInfoButton = infoButton.cloneNode(true);
      infoButton.parentNode.replaceChild(newInfoButton, infoButton);

      // Use mouseover for desktop
      newInfoButton.addEventListener('mouseover', function() {
        const thisIndex = this.dataset.index;
        const infoDetails = document.querySelector(`.cust-easter-calendar__info-details[data-index="${thisIndex}"]`);
        positionInfoDetails(this, infoDetails);
        infoDetails.classList.add('active');
      });

      // Use mouseout to close details
      newInfoButton.addEventListener('mouseout', function() {
        const thisIndex = this.dataset.index;
        const infoDetails = document.querySelector(`.cust-easter-calendar__info-details[data-index="${thisIndex}"]`);
        if (!infoDetails.matches(':hover')) { // Check if mouse is not over infoDetails
          infoDetails.classList.remove('active'); // Close details on mouseout
        }
      });

      // Add mouseover event to infoDetails to keep it open
      const infoDetails = document.querySelector(`.cust-easter-calendar__info-details[data-index="${newInfoButton.dataset.index}"]`);
      if (infoDetails) {
        infoDetails.addEventListener('mouseover', function() {
          infoDetails.classList.add('active'); // Keep details open when hovering over them
        });

        infoDetails.addEventListener('mouseout', function() {
          infoDetails.classList.remove('active'); // Close details when mouse leaves
        });
      }

      // Use click for mobile
      newInfoButton.addEventListener('click', function() {
        const thisIndex = this.dataset.index;
        const infoDetails = document.querySelector(`.cust-easter-calendar__info-details[data-index="${thisIndex}"]`);
        positionInfoDetails(this, infoDetails);
        infoDetails.classList.toggle('active'); // Toggle visibility on click
      });

      // Ensure infoDetails are closed when clicking outside
      document.addEventListener('click', function(event) {
        if (!newInfoButton.contains(event.target) && !infoDetails.contains(event.target)) {
          infoDetails.classList.remove('active'); // Close details if clicking outside
        }
      });
    });

    // Function to position info details
    function positionInfoDetails(button, infoDetails) {
      const buttonRect = button.getBoundingClientRect();
      const parentRect = document.querySelector('.cust-easter-calendar__box-container').getBoundingClientRect();

      let topPosition = buttonRect.top - parentRect.top - infoDetails.offsetHeight - 5; // Position above the button with a small margin
      let leftPosition = buttonRect.left - parentRect.left; // Align with the button

      // Ensure the info details stay within the parent container
      if (topPosition < 0) {
        topPosition = buttonRect.bottom - parentRect.top + 5; // Position below the button if above is out of bounds
      }
      if (leftPosition < 0) {
        leftPosition = 0; // Prevent overflow on the left
      } else if (leftPosition + infoDetails.offsetWidth > parentRect.width) {
        leftPosition = parentRect.width - infoDetails.offsetWidth; // Prevent overflow on the right
      }

      // Adjust top position if it overlaps with the button when positioned below
      if (topPosition + infoDetails.offsetHeight > parentRect.bottom - parentRect.top) {
        topPosition = parentRect.bottom - parentRect.top - infoDetails.offsetHeight - 5; // Position above the bottom of the parent
      }

      // Set the position of the info details
      infoDetails.style.top = `${topPosition}px`;
      infoDetails.style.left = `${leftPosition}px`;
    }
  }

  document.addEventListener("DOMContentLoaded", function() {
    displayInfoDetails();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cust_faq-with-image"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const items = document.querySelectorAll('[data-item]');
    items.forEach(item => {
      item.addEventListener('click', function() {
        this.classList.toggle('active');
        items.forEach(otherItem => {
          if (otherItem !== this) {
            otherItem.classList.remove('active');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-specs-new"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.pdp-specs-new__tab-title');
    const contents = document.querySelectorAll('.pdp-specs-new__tab-content');
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', function() {
        // Hide all contents
        contents.forEach(content => content.classList.remove('active'));
        // Show the corresponding content
        contents[index].classList.add('active');

        // Remove active class from all tabs
        tabs.forEach(tab => tab.classList.remove('active'));
        // Set the clicked tab as active
        tab.classList.add('active');

        let elLeft = tab.offsetLeft;
        let elParent = tab.parentElement;
        let elParentLeft = elParent.offsetLeft;
        let window_width = window.innerWidth / 2;
        // check if element not in view
        if (elLeft > window_width) {
          elParent.parentElement.scrollLeft = elLeft - elParentLeft - window_width + (tab.offsetWidth / 2);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-video"] && !window.DesignMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        (function() {
            // Only initialize if we have video containers with posters
            if (!document.querySelector('.video-container__poster')) {
                return;
            }

            // Store players in a map using container ID as key
            const players = new Map();

            document.querySelectorAll('.video-container__poster').forEach(poster => {
            poster.addEventListener('click', function(e) {
                const container = poster.closest('.video-container__wrapper');
                const videoElement = container.querySelector('[data-video-id]');
                const ytID = videoElement.getAttribute('data-video-id');
                const embed = container.querySelector('.video-container__embed');
                const containerId = container.getAttribute('id');

                playVideo(embed, ytID, containerId, poster);
                poster.style.display = 'none';
                embed.style.display = 'block';

            });
            });

            // Load YouTube IFrame API (only once)
            if (!window.YT) {
                var tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            }

            function playVideo(embed, ytID, containerId, poster) {
                if (!embed) {
                    return;
                }

                // First clear any existing content
                embed.innerHTML = '';

                // Create a new container for the video
                const videoContainer = document.createElement('div');
                videoContainer.className = 'video-container__embed-video';
                embed.appendChild(videoContainer);

                const player = new YT.Player(videoContainer, {
                    videoId: ytID,
                    playerVars: {
                    'playsinline': 1
                    },
                    events: {
                    'onReady': onPlayerReady,
                    'onStateChange': (event) => onPlayerStateChange(event, embed, poster)
                    }
                });

                // Store player reference
                players.set(containerId, player);
            }

            function onPlayerReady(event) {
                event.target.playVideo();
            }

            function onPlayerStateChange(event, embed, poster) {
                // YT.PlayerState.ENDED = 0
                if (event.data === 0) {
                    // Video ended - show poster and hide embed
                    poster.style.display = 'block';
                    embed.style.display = 'none';
                    // Rewind video to beginning
                    event.target.seekTo(0);
                }
            }

            // Clean up players when section is unloaded
            document.addEventListener('shopify:section:unload', function(event) {
                const container = event.target;
                const containerId = container.getAttribute('id');

                if (players.has(containerId)) {
                    const player = players.get(containerId);
                    player.destroy();
                    players.delete(containerId);
                }
            });
        })();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function initializeTestimonialSwiper() {
      var swiperContainer = document.querySelector('.testimonial-slider__block-container--swiper');
      var blockWrapperCount = document.querySelectorAll('.testimonial-slider__block-wrapper').length;

      if (swiperContainer.classList.contains('swiper-initialized')) {
        var existingSwiper = swiperContainer.swiper;
        if (existingSwiper) {
          existingSwiper.destroy();
        }
        swiperContainer.classList.remove('swiper-initialized');
      }

        var swiper = new Swiper(swiperContainer, {
          freeMode: true,
          spaceBetween: 20,
          slidesPerView: 1.19,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            600: {
              slidesPerView: 2.19,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 27,
            },
          },
        });

        swiperContainer.swiper = swiper;
        swiperContainer.classList.add('swiper-initialized');

    }

    initializeTestimonialSwiper();

    window.addEventListener('resize', function () {
      initializeTestimonialSwiper();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
